<template>
  <div class="md-layout">
    <div class="md-layout-item md-small-size-100 md-size-20">
      <md-field>
        <label for="movie">Anrede</label>
        <md-select v-model="movie" name="movie" id="movie">
          <md-option value="fight-club">Herr</md-option>
          <md-option value="godfather">Frau</md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-40">
      <md-field>
        <label>Vorname</label>
        <md-input v-model="firstname" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-40">
      <md-field>
        <label>Nachname</label>
        <md-input v-model="lastname" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-field>
        <label for="role">Funktion</label>
        <md-select v-model="role" name="role" id="role">
          <md-option value="fight-club">Verantwortlicher elkasy</md-option>
          <md-option value="godfather">Systembetreuer</md-option>
          <md-option value="godfather">IT-Ansprechpartner</md-option>
          <md-option value="godfather">Ansprechpartner im Lager</md-option>
          <md-option value="godfather">Rechnungsbearbeiter</md-option>
        </md-select>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-field>
        <label>Email Adresse</label>
        <md-input v-model="emailadress" type="email"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-33">
      <md-field>
        <label>Telefonnummer</label>
        <md-input v-model="phonenumber" type="text"></md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-small-size-100 md-size-100">
      <md-checkbox v-model="requireAccount">Online-Zugang zum Webportal benötigt</md-checkbox>
    </div>
    <div class="md-layout-item md-size-100 text-right">
      <md-button class="md-raised md-primary" @click="this.deleteThis">
        <md-icon>
          delete
        </md-icon>
      </md-button>
    </div>
    <md-divider class="md-layout-item md-small-size-100 md-size-100" style="margin-top: 40px; margin-bottom: 40px;"></md-divider>
  </div>
</template>

<script>
export default {
  name: "AddUserForm",
  methods: {
    deleteThis() {
      this.delete(this);

      this.$destroy();

      // remove the element from the DOM
      this.$el.parentNode.removeChild(this.$el);
    }
  },
  props: {
    delete: {
      type: Function
    }
  }
}
</script>

<style scoped>

</style>
